import api from "@/core/api";

export const list = () => api.query(`/equipments/list`);
